import { mergeProps, splitProps } from "solid-js";
import classNames from "./classnames";
import { Dynamic } from "solid-js/web";
const defaultProps = {
    as: "div",
    type: "valid",
    tooltip: false,
};
const Feedback = (p) => {
    const [local, props] = splitProps(mergeProps(defaultProps, p), [
        "as",
        "class",
        "type",
        "tooltip",
    ]);
    return (<Dynamic component={local.as} {...props} class={classNames(local.class, `${local.type}-${local.tooltip ? "tooltip" : "feedback"}`)}/>);
};
export default Feedback;
